import { useRouter } from "next/router";
import { Menu, Status } from "~components";
import HeaderAlert from "~components/common/common.HeaderAlert";
import { useFacebookPixelScripts } from "~features/analytics/useThirdpartyScripts";
import { Detail } from "~features/events/components/EventDetails/EventDetails";
import { EventAccessStatus, VenueSeating } from "~graphql/sdk";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { useEventAccessControl } from "~hooks/useEventAccessControl";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";
import { useGoogleAnalyticsPageView } from "~hooks/useGoogleAnalytics";

const EventInfoPage = () => {
  const router = useRouter();

  const {
    isLoading,
    event,
    error,
    release,
    accessType,
  } = useEventAccessControl();

  useCampaignReportingOpen(!isLoading);
  useGoogleAnalyticsPageView(router.query.eventId as string);
  useEventTrackingCodes();

  useFacebookPixelScripts(event?.pixelId);

  return (
    <>
      <Menu />
      <Status loading={isLoading} error={error}>
        {accessType === EventAccessStatus.AllowedAdminPreview && (
          <HeaderAlert
            paddingTop={2}
            message="Event preview"
            fixed={event.venue?.seating !== VenueSeating.Seated}
          />
        )}
        <Detail event={event} release={release} />
      </Status>
    </>
  );
};

export default EventInfoPage;
